import { render, staticRenderFns } from "./skilled-professional-details.vue?vue&type=template&id=3ecf8b3e&"
import script from "./skilled-professional-details.vue?vue&type=script&lang=js&"
export * from "./skilled-professional-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports